import { render } from "./LivePodRestarts.vue?vue&type=template&id=e43645ce&scoped=true"
import script from "./LivePodRestarts.vue?vue&type=script&lang=js"
export * from "./LivePodRestarts.vue?vue&type=script&lang=js"

import "./LivePodRestarts.vue?vue&type=style&index=0&id=e43645ce&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e43645ce"]])

export default __exports__